import React from 'react';

import Hero from '../components/Hero';
import FAQCategoryCard from '../components/FAQCategoryCard';
import Section from '../components/Section';

export default function FAQTemplate({ pageContext: { page, entries } }) {
  return (
    <React.Fragment>
      <Section size="small">
        <Hero {...page} />
      </Section>

      <Section size="small" colour="light">
        <div className="mx-2 px-2 grid gap-2 grid-cols-1 sm:mx-4 sm:px-auto sm:grid-cols-2 md:gap-4 lg:grid-cols-3">
          {entries.map((entry) => (
            <FAQCategoryCard key={entry.id} {...entry} />
          ))}
        </div>
      </Section>
    </React.Fragment>
  );
}
